<div class="sm:py-2 sm:px-6">
  <h2 class="m-0 mb-2 font-medium">Add a photo</h2>
  <p class="description m-0 mb-2 font-medium">
    <!-- To get started, please upload a profile. This helps personalize your experience. -->
    To continue, please upload a profile photo. This helps personalize your experience and ensures a complete profile.
  </p>
  <div class="upload-box" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
    [class.active]="isDragging">
    <p *ngIf="!selectedFile" class="sm:text-lg text-sm">Drop image here or <span class="browse"
        (click)="onBrowseClick()">browse</span></p>
    <p *ngIf="selectedFile">{{ selectedFile.name }}</p>
    <p class="supported">Supports JPEG, JPEG 2000, PNG</p>
    <input type="file" accept="image/*" #fileInput (change)="onFileSelected($event)" hidden />
  </div>
  <div class="actions">
    <button mat-button type="button" (click)="onCancel()" class="blue-back">Cancel</button>
    <button mat-button class="markAs-complete" type="button" [disabled]="!selectedFile || isUploading" (click)="onSave()">
      <mat-spinner *ngIf="isUploading" diameter="20"></mat-spinner>
      <span *ngIf="!isUploading">Save</span>
    </button>
  </div>
</div>